export enum Tags {
  Init = "init",
  DataMapping = "dataMapping",
  Invoices = "invoices",
  Invoice = "invoice",
  Customers = "customers",
  ConnectionStatus = "connectionStatus",
  Permissions = "permissions",
  Products = "products",
  TaxCodes = "taxCodes"
}
